<template>
  <div>
    <mButton class="cell-bar-span"
          @click="handleClick(item)"
          v-for="(item,index) in opers"
          v-if="item.operShowPosition === 'table'"
             size="xs"
             :key="index" :title="item.name">
      <span v-if="show === 'textIcon'">
         <Icon :type="item.iconClass" />{{item.title}}
      </span>
      <span v-else-if="show === 'text'">
        {{item.title}}
      </span>
      <span v-else>
         <Icon :type="item.iconClass" :title="item.title"/>
      </span>
    </mButton>
  </div>
</template>

<script>
  import mButton from '@/components/button/m-button'
    export default {
        name: "cell-bar",
      props:{
        show: {
          type: String,
          default: 'textIcon'
        },
        condition:String,
      },
      components:{mButton},
      data(){
          return{
            opers:[],
          }
      },
      created(){
        let funcId = this.$route.query.paasCurrentFunctionId;
        if(funcId===undefined){
          funcId = this.$store.state.defaultFuncId;
        }
        /**
         * 用于操作
         * */

        let funcOperMap = this.$store.state.funcOperMap;
        if(JSON.stringify(funcOperMap) !== {} && window.localStorage.getItem("funcOperMap")){
              funcOperMap = JSON.parse(window.localStorage.getItem("funcOperMap"));
              this.$store.commit('setFuncOperMap', funcOperMap);
        }
        if(funcOperMap){
          this.opers = funcOperMap[funcId].opers;
        }
        let cellOpers = [];
        if(this.condition){
          for(let i=0;i<this.opers.length;i++){
            if(this.condition.indexOf(this.opers[i].operCode) === -1){
              cellOpers.push(this.opers[i]);
            }
          }
          this.opers = cellOpers;
        }
      },
      methods:{
        handleClick(item){
          this.$emit(item.operCode);
        }
      }
    }
</script>

<style scoped>
 .cell-bar-span{
    margin-right:3px;
    cursor:pointer;
    font-size: 12px;
  }
  .cell-bar-img{
    width: 16px;
    margin-right: 5px;
    vertical-align: middle;
    margin-bottom:3px;
  }
</style>
